import mapValues from 'lodash-es/mapValues'

import { EMPTY_LIST } from '../../../../constants/common'
import { REQUEST_STATUS } from '../../../../constants/request'
import {
  toBirdviewChartSection,
  toBirdviewSeriesSection,
} from '../../DashboardBirdview.utils.charts'

import {
  BIRDVIEW_CHART_AGING_BUCKETS,
  BIRDVIEW_CHART_CUSTOMER_SEGMENTS,
  BIRDVIEW_CHART_REQUEST_STATUS_SEGMENTS,
} from './useBirdviewAnalyticsLoaders.constants'

function getBirdviewRequestStatusSegments() {
  return BIRDVIEW_CHART_REQUEST_STATUS_SEGMENTS.map(({ color, status }) => ({
    apiKey: status,
    color,
    labelKey: REQUEST_STATUS[status].text,
  }))
}

function toBirdviewFlowPoint(item) {
  return {
    closed: item.closed,
    date: item.date,
    dateTo: item.date_to,
    isPartial: item.partial,
    opened: item.opened,
  }
}

function toBirdviewSegmentChartItems(values, segments) {
  return segments.map(segment => ({
    ...segment,
    id: segment.apiKey,
    value: values[segment.apiKey],
  }))
}

// The API totals cover the whole period, so they are not summed from the points.
export function toBirdviewFlowSection(data) {
  return {
    ...toBirdviewSeriesSection(data.items.map(toBirdviewFlowPoint)),
    closed: data.closed_total,
    opened: data.opened_total,
  }
}

export function toBirdviewStatusSection(data) {
  return toBirdviewChartSection(
    toBirdviewSegmentChartItems(
      Object.fromEntries(data.items.map(item => [item.status, item.count])),
      getBirdviewRequestStatusSegments()
    )
  )
}

export function toBirdviewCustomersSection(statistic) {
  return mapValues(BIRDVIEW_CHART_CUSTOMER_SEGMENTS, segments =>
    toBirdviewChartSection(toBirdviewSegmentChartItems(statistic, segments))
  )
}

// A zero bucket keeps its column; only a portfolio without open requests is empty.
export function toBirdviewAgingSection({ basis, data }) {
  return {
    items:
      data.total > 0
        ? toBirdviewSegmentChartItems(
            Object.fromEntries(data.items.map(row => [row.bucket, row[basis]])),
            BIRDVIEW_CHART_AGING_BUCKETS
          )
        : EMPTY_LIST,
    total: data.total,
  }
}
